export const issuedCertificatesApiHandler = {
  getOrganizationIssuedCertificates: {
    method: "GET",
    path: () => `org-certificates`,
    params: {} as {'skip'?: string | number, 'take'?: string | number, 'search'?: string | number, 'orderBy[createdAt]'?: string | number, 'orderBy[course][name]'?: string | number, 'orderBy[user][firstName]'?: string | number, 'orderBy[course][organization][name]'?: string | number}
  }
};